import { Button, Form, Input } from 'antd';
import { useEffect, useState } from 'react';
import login from '../../assets/images/login/nudosIcon.svg';
import minLogo from '../../assets/images/login/minLogo.svg';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { getLoggedUserPermissions } from '../../services/configuration.service';
import { LoadingOutlined } from '@ant-design/icons';
import { NudosLinkTypeButton } from '../../components/NudosComponents';
import { isEmailValid } from '../../utils/formValidations';
import { useUserAuth } from '../../state/userAuthContext';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';

interface IDataUser {
  userNudos: string;
  passwordNudos: string;
}

const LogIn = () => {
  const { resetPassword } = useUserAuth();
  const [, forceUpdate] = useState({});
  const [form] = Form.useForm();
  const userNudos = Form.useWatch('userNudos', form);
  const passwordNudos = Form.useWatch('passwordNudos', form);
  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    forceUpdate({});
  }, []);

  const validEmail = isEmailValid(userNudos);

  const onFinish = (values: IDataUser) => {
    setLoading(true);
    const email = values.userNudos;
    const password = values.passwordNudos;
    const auth = getAuth();
    signInWithEmailAndPassword(auth, email, password)
      .then(async userCredential => {
        const user = userCredential.user;
        const objUser = { email: user.email, phone: user.phoneNumber, user: user.displayName, uuid: user.uid };
        const nudosData = await getLoggedUserPermissions(user.uid);
        localStorage.setItem('userNudosData', JSON.stringify(nudosData));
        localStorage.setItem('_userInfo', JSON.stringify(objUser));

        window.location.href = '/dashboard/dashboard';
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        displayErrorNotification({ customJSXMessage: <>Ocurrio un error intente mas tarde</> });
      });
  };

  return (
    <div id="signIn">
      <div className="sogaContainer">
        <div className="boxText">
          <div className="welcomeTitle">Bienvenido </div>
          <div className="welcomeSubtitle">a Soga</div>
        </div>
        <div className="topFloat">
          <div className="containerIcon">
            <img alt="loginIcon" src={minLogo} />
          </div>
        </div>
        <div className="floatContainer">
          <div className="containerIcon">
            <img alt="loginIcon" src={login} />
          </div>
        </div>
      </div>
      <div className="formContainer">
        <div className="containerLogIn">
          <div className="verticalCenter">
            <Form onFinish={onFinish} form={form} name="login_user">
              <div className="containerItems">
                <div className="separateInput">
                  <div className="title">Iniciar sesión </div>
                  <div className="subtitle">Escribe tu correo para poder ingresar</div>
                  <div className={!userNudos ? 'colorGray' : ''}>Correo</div>
                  <Form.Item
                    name="userNudos"
                    rules={[
                      { required: true, message: 'campo requerido' },
                      { type: 'email', message: 'email no valido' }
                    ]}
                  >
                    <Input type="email" placeholder="juanita@somosnudos.com" className="inputLogin" />
                  </Form.Item>
                </div>
                <div className="separateItems">
                  <div className={!passwordNudos ? 'colorGray' : ''}>Contraseña</div>
                  <Form.Item name="passwordNudos" rules={[{ required: true, message: 'campo requerido' }]}>
                    <Input.Password type="password" placeholder="********" className="inputLogin" />
                  </Form.Item>
                  <NudosLinkTypeButton
                    text="Recuperar contraseña"
                    hideIcon
                    isDisabled={!validEmail}
                    handleClickCallback={() => resetPassword && resetPassword(userNudos)}
                  />
                </div>
                <Form.Item className="positionButton" shouldUpdate>
                  {() => (
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={
                        loading ||
                        !form.isFieldsTouched(true) ||
                        !!form.getFieldsError().filter(({ errors }) => errors.length).length
                      }
                      className="buttonLogin"
                    >
                      {loading ? <LoadingOutlined style={{ fontSize: '25px' }} /> : 'Iniciar sesión'}
                    </Button>
                  )}
                </Form.Item>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogIn;
